import React from 'react'
import './Gallery.scss'
// import gal1 from '../../img/gal-1.jpeg'
// import gal2 from '../../img/gal-2.jpeg'
import {galleryImage} from '../../data'
export const Gallery = () => {

 
    return (
        <section className="gallery">
       {      galleryImage.map(data => {
         return ( <figure className={`gallery__item ${data.className}`}>
            <img src={data.img} alt={data.alt} className="gallery__img"></img>

            </figure>
         )})}
            {/* <figure className="gallery__item gallery__item--1">
            <img src={gal1} alt="Gallery-image1" className="gallery__img"></img>

            </figure>

            <figure className="gallery__item gallery__item--2">
            <img src={gal2} alt="Gallery-image2" className="gallery__img"></img>

            </figure> */}

        </section>
    )
}
